export function formatRuPhone(phone: string): string {
  const cleanPhone = phone.replace(/\D/g, '')

  if (cleanPhone.length !== 11) {
    return phone
  }

  const normalizedPhone = cleanPhone.startsWith('8')
    ? `7${cleanPhone.slice(1)}`
    : cleanPhone

  if (!normalizedPhone.startsWith('7')) {
    return phone
  }

  const countryCode = normalizedPhone.slice(0, 1)
  const areaCode = normalizedPhone.slice(1, 4)
  const firstPart = normalizedPhone.slice(4, 7)
  const secondPart = normalizedPhone.slice(7, 9)
  const thirdPart = normalizedPhone.slice(9, 11)

  return `+${countryCode} (${areaCode})-${firstPart}-${secondPart}-${thirdPart}`
}

export function callPhone(phone: string): void {
  window.location.href = `tel:${phone.replace(/\s/g, '')}`
}
